var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"illustration-choice"},[_c('p',[_vm._v("イラストを選択してください")]),_vm._v(" "),_c('img',{class:[_vm.active === 0 ? 'active-bg' : ''],attrs:{"src":_vm.avatar.img},on:{"click":function($event){_vm.selectIllust(); _vm.active = 0;}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a5b8ac6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/SelectIllustrationPage.vue
// module id = null
// module chunks = 